// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import {
  FixedTextInput as RandAmountInput,
  Checkbox
} from '../'


export class AllOrSpecificAmountInput extends PureComponent {
  static propTypes = {
    id: PropTypes.string,
    sourceAccountBalance: PropTypes.string.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    allSelected: PropTypes.bool,
    className: PropTypes.string
  }

  static defaultProps = {
    id: 'amount',
    disabled: false,
    className: ''
  }

  render() {
    const { value, sourceAccountBalance, onChange, disabled, allSelected, className } = this.props

    return (
      <div style={{ borderLeft: '3px solid whitesmoke' }} className={className}>
        <div title='Selected whole invested amount to withdraw' className='slds-grid'>
          <Checkbox
            onChange={() => onChange('100', 'percentage')}  // amount & amount type
            checked={allSelected}
            value={sourceAccountBalance}
            disabled={disabled}
            className='slds-p-left_x-small slds-m-right_x-small'
          />
          All
          {allSelected &&
            <div className='slds-m-left_small slds-text-color_weak'>
              {`(current balance: R ${sourceAccountBalance})`}
            </div>
          }
        </div>
        <div className='slds-p-around_xx-small slds-p-left_medium slds-text-color_weak'>
          OR
        </div>
        <div>
          <RandAmountInput
            placeholder='Enter specific amount'
            text='R'
            value={allSelected
              ? ''
              : value
            }
            disabled={disabled}
            onChange={e => onChange(e.target.value)}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/withdrawal-add-edit-modal/AllOrSpecificAmountInput.js